import { AppEnvironment } from './environment.model';

const apiBaseUrl = 'https://ciamcom-api-dev-b3bfb3gvend8h9hm.westeurope-01.azurewebsites.net';

export const environment = {
  production: false,
  apiBaseUrl,
  apiUrl: `${apiBaseUrl}/api/`,
  refreshIntervals: {
    dashboardMilliseconds: 20_000,
    queueMilliseconds: 10_000,
    runLogsMilliseconds: 3_000,
  },
  auth: {
    authority: 'https://ciam-dev.acp-gruppe.com',
    clientId: 'daaaacac-044b-44ce-aed5-d559f185aa8b',
    redirectUri: `${window.location.origin}/dashboard`,
    postLogoutRedirectUri: `${window.location.origin}/login`,
    scope: 'openid profile offline_access groups roles',
    secureRoutes: [
      apiBaseUrl,
      `${apiBaseUrl}/api/`,
    ],
  },
} satisfies AppEnvironment;
